export const SocialContent = [
  {
    link: 'https://www.linkedin.com/in/glapachishvili/',
    img: 'linkedin',
  },
  {
    link: 'https://github.com/Lythmass',
    img: 'github',
  },
];

export default SocialContent;
